<template>
  <div class="page-container">
    <el-card shadow="none">
      <!-- <span class="span-lable">座席名称：</span>
      <el-input v-model="cnoName" placeholder="请输入座席名称" class="input-width" size="small"></el-input> -->
      <span class="span-lable ml-20">座席状态：</span>
      <el-select v-model="bindStatus" placeholder="请选择座席状态" size="small" class="input-width mb-5">
        <el-option v-for="(item,index) in bindStatusList" :key="index" :label="item.name" :value="item.value" />
      </el-select>
      <span class="span-lable ml-20">座席号：</span>
      <el-input v-model.trim="cnoNo" placeholder="请输入座席号" class="input-width" size="small"></el-input>
      <span class="span-lable ml-20">外呼员工：</span>
      <!-- <el-select v-model="userIds" placeholder="请选择外呼员工" size="small" style="width:240px;" filterable multiple collapse-tags>
        <el-option v-for="(item,index) in customerEmpoyArr" :key="index" :label="item.accountName" :value="item.id"></el-option>
      </el-select> -->
      <el-cascader popper-class="cascader-department" ref="cascader" size="small" style="width:240px;" filterable placeholder="请选择外呼员工" :options="options" :show-all-levels="false" :props="props"
        v-model="ownerValue" collapse-tags clearable @change="changeCascader"></el-cascader>
      <el-button type="primary" class="ml-20 mt-5" size="small" @click="getCurrentAccountClients">查询</el-button>
      <el-button size="small" @click="clickReset">重置</el-button>
    </el-card>

    <div class="div-table mt-10">
      <p class="p-title mt-10 mb-20">
        <span class="span-text1">剩余数量</span>
        <span class="span-text2">/座席总数量</span>
        <span class="span-text3 ml-20">{{ totalData.remainCounts || 0 }}</span>
        <span class="span-text4">/{{ totalData.totalCounts || 0 }}</span>
        <span class="fr">
          <el-button size="mini" type="primary" @click="getMultipleSupplierUser()">新增座席</el-button>
        </span>
      </p>
      <el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" :header-cell-style="{background:'#F2F4F7',fontWeight: '400',color:'#303133'}">
        <el-table-column label="座席号">
          <template slot-scope="scope">{{ scope.row.userCnoNo }}</template>
        </el-table-column>
        <!-- <el-table-column prop="cnoName" label="座席名称">
        </el-table-column> -->
        <!-- <el-table-column prop="cnoAreaCode" label="所属区号" show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column prop="bindStatus" label="状态">
          <template #default="scope">
            <play-status v-if="scope.row.bindStatus=='已绑定'" type="success">已绑定</play-status>
            <play-status v-else type="error">未绑定</play-status>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="使用员工" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="!isSpecialSupplier" prop="clidType" label="外显类型">
          <template #default="scope">{{scope.row.clidType === 0 ? "固定号码" : scope.row.clidType === 1 ? "动态外显" : scope.row.clidType === 2 ? "智能外显" : '--'}} </template>
        </el-table-column>
        <el-table-column v-if="!isSpecialSupplier" prop="clidNumber" label="外显号码" :min-width="numberLength == 11 ? '76': numberLength == 12 ? '80':numberLength == 13 ? '84':'90'">
          <template #default="scope">
            <el-popover v-if="scope.row.clidNumber && scope.row.clidNumber !='--'" placement="top" popper-class="clue-popo-height"
              :width="numberLength == 11 ? '276': numberLength == 12 ? '296':numberLength == 13 ? '316': '326'" trigger="hover">
              <div class="div-clue-popo">
                <p>{{scope.row.clidNumber}}</p>
              </div>
              <span slot="reference" class="max-text">{{scope.row.clidNumber}}</span>
            </el-popover>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="cnoBindTel" label="绑定号码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cnoTelType" label="号码类型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cnoType" label="坐席类型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callModelDesc" label="线路模式" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.supplierCode!=='ls'&&scope.row.supplierCode!=='rx'" type="text" @click="clickEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #999999;" @click="deleteClient(scope.row)" v-if="scope.row.bindStatus!='已绑定'">删除</el-button>
            <el-button type="text" style="color: #374FB8;" @click="unbindClientUser(scope.row)" v-if="scope.row.bindStatus=='已绑定'">解绑</el-button>
            <el-button type="text" style="color: #374FB8;" @click="clickAllot(scope.row)" v-else>分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pageNum="pageNum" :pageSize="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" style="margin-top:80px;"></pagination>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false" @close="handleClose">
      <!-- <tipBox class="tipbox" style="margin-left: 14px;width:98%;margin-bottom: 35px;" :type="'warning'">
        <div style="font-size: 12px;">由于政策管控，外显号码存在被标记风险，如遇到标记情况请更换号码或联系商务处理</div>
      </tipBox> -->
      <el-form :model="ruleForm" @submit.native.prevent :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="外呼员工：" prop="bindUserId" v-if="dialogTitle === '分配'">
          <el-select v-model="ruleForm.bindUserId" placeholder="请选择外呼员工" size="small" style="width:100%;" filterable :popper-append-to-body="false" @change="changeUser">
            <el-option v-for="(item, index) in structureList" :key="index" :label="item.accountName" :value="item.userId" />
          </el-select>
        </el-form-item>
        <template v-else>
          <el-form-item label="座席号：" prop="cnoNo">
            <el-input v-model="ruleForm.cnoNo" size="small" :disabled="ruleForm.bindStatus === '已绑定'" @input="getCnoNo" placeholder="请输入坐席号，1-5位数字，要求唯一"></el-input>
          </el-form-item>
          <el-form-item label="线路模式：" v-if="dialogTitle === '新增座席'&&modeOptions.length" prop="callModel" class="showNumber-box position-error">
            <el-radio-group v-model="ruleForm.callModel" @change="handleChangeModel">
              <!-- status:1 没有开通这个线路 -->
              <el-radio v-for="(item,index) in modeOptions" :key="index" :label="item.callModel" :disabled="item.clientCount==0">{{item.name}}(剩余{{item.clientCount}}个)</el-radio>
            </el-radio-group>
            <p v-if="ruleForm.callModel == 0" class="tipsWaring"> <i class="el-icon-info"></i> 外显全新手机虚拟号，可以绑定多个号码，支持智能外显，不能回拨</p>
            <p v-if="ruleForm.callModel == 1" class="tipsWaring"> <i class="el-icon-info"></i> 外显真实认证绑定的手机号码，可回拨，可加V，不支持智能外显</p>
          </el-form-item>
          <el-form-item label="线路模式：" v-if="dialogTitle === '编辑座席'||dialogTitle === '分配'" prop="clidType" class="showNumber-box">
            <el-radio :label="currentMode.callModel" :disabled="ruleForm.bindStatus === '已绑定'" v-model="currentMode.callModel">{{currentMode.name}}</el-radio>
            <p v-if="currentMode.callModel == 0" class="tipsWaring"> <i class="el-icon-info"></i> 外显全新手机虚拟号，可以绑定多个号码，支持智能外显，不能回拨</p>
            <p v-if="currentMode.callModel == 1" class="tipsWaring"> <i class="el-icon-info"></i> 外显真实认证绑定的手机号码，可回拨，可加V，不支持智能外显</p>
          </el-form-item>
          <template v-if="ruleForm.supplierCode!=='ls'&&ruleForm.supplierCode!=='rx'">
            <el-form-item label="外显号码：" prop="clidType" class="showNumber-box">
              <el-radio-group v-model="ruleForm.clidType" @change="handleRedio">
                <el-radio :label="0">固定号码</el-radio>
                <el-radio :label="1">动态外显</el-radio>
                <el-radio :label="2">智能外显</el-radio>
              </el-radio-group>
              <p v-if="ruleForm.clidType == 0" class="tipsWaring"> <i class="el-icon-info"></i> 选择1个号码，呼叫时固定显示</p>
              <p v-else-if="ruleForm.clidType == 1" class="tipsWaring"> <i class="el-icon-info"></i> 可选择多个号码，呼叫时根据外显规则动态显示</p>
              <p v-else-if="ruleForm.clidType == 2" class="tipsWaring"> <i class="el-icon-info"></i> 匹配被叫号码区号外显，未匹配则显示省会号码，还未匹配则从缺省号码中随机显示</p>
            </el-form-item>
            <el-form-item label="外显规则：" prop="clidRule" v-if="ruleForm.clidType == 1">
              <el-radio-group v-model="ruleForm.clidRule">
                <el-radio :label="1">随机</el-radio>
                <el-radio :label="2">轮选</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="轮选设置：" prop="rollTimes" v-if="ruleForm.clidRule == 2 && ruleForm.clidType == 1">
              每 <el-input v-model="ruleForm.rollTimes" @input="getRollTimes" style="width:10%" size="small" class="ruleTimes_ipt"></el-input> 次外呼，更换一次外显号码 <span style="color:#999999">（可设置1~30次）</span>
            </el-form-item>
            <!-- 单选选择号码 -->
            <el-form-item v-if="ruleForm.clidType == 0" label="选择号码：" prop="clidNumber_single" class='selectNumber-box'>
              <div class="select-box">
                <el-cascader :key="ruleForm.clidType" :options="options_clidNumbers" :props="props_selectSingle" collapse-tags clearable placeholder="请选择号码" v-model="ruleForm.clidNumber_single"
                  popper-class="tree-selectNumber-box" ref="selctNumberCascader" size="small" style="width:431px;" :show-all-levels="false" filterable>
                </el-cascader>
              </div>
            </el-form-item>
            <!-- 动态多选号码 -->
            <el-form-item v-else-if="ruleForm.clidType == 1" label="选择号码：" prop="clidNumber_more" class="selectNumber_box">
              <div class="select-box">
                <el-cascader :options="options_clidNumbers" :props="props_clidNumbers" collapse-tags clearable placeholder="请选择号码" v-model="ruleForm.clidNumber_more"
                  popper-class="tree-selectNumber-box" ref="selctNumberCascader" size="small" style="width:431px;" :show-all-levels="false" filterable>
                </el-cascader>
              </div>
            </el-form-item>
            <!-- 智能多选号码 -->
            <el-form-item v-else label="选择号码：" prop="clidNumber11" class="selectNumber-box1">
              <div class="select-box">
                <el-cascader :options="options_clidNumbers" :props="props_clidNumbers" collapse-tags clearable placeholder="请选择号码" v-model="ruleForm.clidNumber11" popper-class="tree-selectNumber-box"
                  ref="selctNumberCascader" size="small" style="width:431px;" :show-all-levels="false" filterable>
                </el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="缺省外显号码：" prop="defaultClidNumber11" v-if="ruleForm.clidType == 2" label-width="120px" style="width:320px;">
              <el-cascader :options="options_defaultClidNumbers" :props="props_defaultClidNumbers" collapse-tags clearable placeholder="请选择外显号码" v-model="ruleForm.defaultClidNumber11"
                popper-class="tree-selectNumber-box" ref="selctNumberCascader" size="small" style="width:431px;" :show-all-levels="false" filterable></el-cascader>
            </el-form-item>
          </template>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clickSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import { debounce } from '@/base/global'
import {
  getCurrentAccountClients, createClient, queryScrmUsers, editCurrentAccountClient, getExon, getClientCount, deleteClient, unbindClientUser, queryCurrentAccountClient,
  manualBindCallCenterUserClient, getAearNumberList, getMultipleSupplierUser, getDepartUserStructure
} from '../api'
// import { mapState } from 'vuex'
import PlayStatus from '../component/PlayStatus'

export default {
  name: 'seatManage',
  components: { PlayStatus, pagination },
  data () {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入座席名称'))
      } else {
        var reg = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
        if (reg.test(value) && value.length <= 20) {
          callback()
        } else {
          callback(new Error('只允许输入中文、字母、数字、下划线，长度不超过20个字符'))
        }
      }
    }
    return {
      ownerValue: [],
      props: { multiple: true, label: 'value', value: 'id', children: 'childList' },
      props_clidNumbers: { multiple: true, label: 'value', children: 'childs', value: 'key' },
      props_selectSingle: { label: 'value', children: 'childs', value: 'key' },
      props_defaultClidNumbers: { multiple: true, label: 'value', children: 'childs', value: 'key' },
      options: [], // type 类型 1：部门 2：员工
      options_clidNumbers: [],
      options_defaultClidNumbers: [],
      rules: {
        cnoNo: [
          { required: true, message: '请输入座席号', trigger: 'blur' },
          { min: 1, max: 5, message: '建议1-5位数字', trigger: 'blur' }
        ],
        name: [{ required: true, validator: validateName, trigger: 'blur' }],
        // areaCode: [{ required: true, message: '请输入所属区号', trigger: 'blur' }],
        // clidNumber: [{ required: true, message: '请选择外显号码', trigger: 'change' }],
        clidType: [{ required: true, message: '请选择外显号码', trigger: 'change' }], // 外显号码
        clidNumber_single: [{ required: true, message: '请选择号码', trigger: 'change' }], // 固定选择号码
        clidNumber_more: [{ required: true, message: '请选择号码', trigger: 'change' }], // 动态选择号码
        clidNumber11: [{ required: true, message: '请选择号码', trigger: 'change' }], // 智能选择号码
        clidRule: [{ required: true, message: '请选择外显规则', trigger: 'blur' }], // 外显规则
        rollTimes: [
          { required: true, message: '请输入轮选次数', trigger: 'blur' },
          { pattern: /^([12][0-9]|30|[1-9])$/, message: '仅支持设置1-30次', trigger: 'blur' }
        ], // 轮选次
        defaultClidNumber11: [{ required: true, message: '请选择缺省外显号码', trigger: 'change' }], // 缺省外显号码
        bindUserId: [
          { required: true, message: '请选择外呼员工', trigger: 'change' }
        ],
        callModel: { required: true, message: '请选择线路模式', trigger: 'change' }
      },
      ruleForm: {
        userName: '',
        cnoNo: '',
        name: '',
        bindUserId: '', // 外呼员工id
        // areaCode: '',
        clidNumber11: [], // 多选_选择号码
        clidNumber_single: [], // 单选_选择号码
        clidNumber_more: [], /// 动态选择号码
        clidNumbers: [], // (接口入参)选择号码
        clidType: 0, // 外显号码规则
        clidRule: 1, // 外显规则
        rollTimes: 1, // 轮选次
        defaultClidNumber11: [], // 缺省外显号码
        defaultClidNumbers: [], // (接口入参)缺省外显
        callModel: '' // 线路模式(仅同一个租户内自由切换两种供应商)
      },
      testNum: null,
      cnoName: '', // 座席名称
      // clidNumber: '', // 外显号码
      // cnoAreaCode: '', // 所属区号
      cnoNo: '', // 座席号
      bindStatus: null, // 座席状态
      bindStatusList: [
        // { value: null, name: '全部' },
        { value: 0, name: '已绑定' },
        { value: 1, name: '未绑定' }
      ],
      userIds: [], // 外呼员工
      structureList: [],
      customerEmpoyArr: [],
      clidList: [], // 外显列表
      totalData: {},
      dialogVisible: false,
      dialogTitle: '新增座席',
      tableData: [],
      // 分页
      pageNum: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      reCnoNo: '', // 编辑重新赋值给座席号
      cnoNoAdd: '', // 添加重新赋值给座席号
      numberLength: '', // 外显号码的长度
      modeOptions: [],
      modeLists: [
        { callModel: 0, name: '虚拟号直拨线路' },
        { callModel: 1, name: '真实号回拨线路' }
      ],
      currentMode: {}
    }
  },
  computed: {
    /**
     * 供应商及猫 ls
     * 1、隐藏: 外显类型、外显号码列，无【编辑】按钮
     * 2、新增座席：只显示坐席号
     */
    isSpecialSupplier () {
      return this.$store.state.user.supplierCode === 'ls' || this.$store.state.user.supplierCode === 'rx'
    }
    // ...mapState({ supplierCode: state => state.user.supplierCode })
  },
  mounted () {
    this.getCurrentAccountClients()
    this.queryScrmUsers()
    this.getExon()
    // this.$bus.$on('refresh', (val) => {
    //   this.getCurrentAccountClients()
    // })
  },
  updated () {
    this.fixCascader()
  },
  methods: {
    fixCascader () {
      const cascader = document.querySelectorAll('.el-cascader__search-input')
      for (let index = 0; index < cascader.length; index++) {
        cascader[index].setAttribute('placeholder', '')
      }
    },
    // 切换外显号码清空校验
    handleRedio (callback) {
      this.$refs.ruleForm.fields.forEach((e) => {
        if (e.prop == 'clidNumber_single' || e.prop == 'clidNumber11' || e.prop == 'clidNumber_more' ||
          e.prop == 'defaultClidNumber11' || e.prop == 'clidRule' || e.prop == 'rollTimes' || e.prop == 'clidType') {
          e.resetField()
        }
      }) // 指定重置校验
      this.ruleForm.clidNumber_single = []
      this.ruleForm.clidNumber11 = []
      this.ruleForm.clidNumber_more = []
      this.ruleForm.defaultClidNumber11 = []
      this.ruleForm.rollTimes = 1
      this.ruleForm.clidType = callback
      if (this.dialogTitle == '编辑座席') {
        this.ruleForm.cnoNo = this.reCnoNo
        if (this.cnoNoAdd) {
          this.ruleForm.cnoNo = this.cnoNoAdd
        }
      } else if (this.dialogTitle == '新增座席') {
        this.ruleForm.cnoNo = this.cnoNoAdd
      }
      if (callback == 1) {
        this.ruleForm.clidRule = 1
      }
    },
    // 关闭弹层清空
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.ruleForm.clidNumber_single = []
      this.ruleForm.clidNumber11 = []
      this.ruleForm.defaultClidNumber11 = []
      this.ruleForm.cnoNo = ''
    },
    // 获取输入座席号
    getCnoNo () {
      this.ruleForm.cnoNo = this.ruleForm.cnoNo.replace(/[^\d]/g, '')
      this.cnoNoAdd = this.ruleForm.cnoNo
    },
    // 输入轮选次
    getRollTimes () {
      if (this.ruleForm.rollTimes) {
        this.ruleForm.rollTimes = this.ruleForm.rollTimes.replace(/\D|^0/g, '')
      }
    },
    changeCascader () {
      this.userIds = []
      this.ownerValue.forEach(e => {
        this.userIds.push(e[e.length - 1])
      })
      this.getCurrentAccountClients()
    },
    getOptions (arr) {
      if (arr && arr.length) {
        arr.forEach(e => {
          this.$set(e, 'disabled', false)
          if (e.type == 2) {
            delete e.childList
          }
          if (e.type == 1 && (e.childList == undefined || e.childList == null || !e.childList || !e.childList.length || e.containFlag !== 1)) {
            e.disabled = true
          }
          if (e.childList && e.childList.length) {
            this.getOptions(e.childList)
          } else {
            delete e.childList
          }
        })
      }
    },
    getDepartUserStructure () {
      getDepartUserStructure().then(res => {
        this.options = res.data
        this.getOptions(this.options)
      }).catch(_ => { })
    },
    changeUser () {
      if (this.ruleForm.bindUserId) {
        this.structureList.forEach(e => {
          if (e.userId == this.ruleForm.bindUserId) {
            this.ruleForm.userName = e.accountName
          }
        })
      } else {
        this.ruleForm.userName = ''
      }
    },
    clickAllot (row) {
      this.dialogTitle = '分配'
      this.dialogVisible = true
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.ruleForm = {
        id: row.id,
        userName: '',
        bindUserId: '',
        supplierCode: row.supplierCode
      }
    },
    unbindClientUser (row) {
      this.$confirm('您确定要解绑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unbindClientUser({ cnoNos: [row.userCnoNo], supplierCode: row.supplierCode }).then(res => {
          this.$message.success('解绑成功')
          this.getCurrentAccountClients()
        })
      }).catch(() => { })
    },
    deleteClient (row) {
      this.$confirm('请确认是否删除席位', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteClient({ id: row.id, supplierCode: row.supplierCode }).then(res => {
          this.$message.success('删除成功')
          this.getCurrentAccountClients()
        })
      }).catch(() => { })
    },
    getClientCount () {
      getClientCount().then(res => {
        this.totalData = res.data
      })
    },
    clickReset () {
      this.ownerValue = []
      this.pageNum = 1
      this.pageSize = 20
      this.cnoName = ''
      this.cnoNo = ''
      this.bindStatus = ''
      this.userIds = []
      this.getCurrentAccountClients()
    },
    getExon () {
      getExon().then(res => {
        this.clidList = res.data
      })
    },
    // 编辑座席
    clickEdit (row) {
      this.cnoNoAdd = ''
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      queryCurrentAccountClient({ id: row.id, supplierCode: row.supplierCode }).then(res => {
        this.dialogVisible = true
        this.dialogTitle = '编辑座席'
        const selectedNumbers = Array.isArray(res.data.selectedNumbers) ? res.data.selectedNumbers : []
        this.getAearNumberList()
        this.reCnoNo = res.data.userCnoNo
        this.ruleForm = {
          id: res.data.id,
          cnoNo: res.data.userCnoNo,
          name: res.data.cnoName,
          bindStatus: row.bindStatus,
          // areaCode: res.data.cnoAreaCode,
          clidNumber_single: res.data.clidType == 0 ? selectedNumbers[0] : [],
          clidNumber_more: res.data.clidType == 1 ? selectedNumbers : [],
          clidNumber11: res.data.clidType == 2 ? selectedNumbers : [],
          clidRule: res.data.clidRule,
          clidType: res.data.clidType,
          rollTimes: res.data.rollTimes,
          defaultClidNumber11: res.data.selectedDefaultNumbers,
          supplierCode: row.supplierCode
        }
        this.currentMode = this.modeLists.find(item => item.callModel === res.data.callModel)
      })
    },
    // 选择号码
    getAearNumberList () {
      getAearNumberList().then(res => {
        var array = res.data
        this.options_clidNumbers = array
        this.options_defaultClidNumbers = array
      })
    },
    handleChangeModel (val) {
      const model = this.modeOptions.find(item => item.callModel === val)
      if (model) {
        this.ruleForm.supplierCode = model.supplierCode
      }
    },
    getMultipleSupplierUser () {
      getMultipleSupplierUser({}).then(res => {
        // callModelSmall = {
        //   status: 0,   // 1 没有开通线路
        //   callModel: 0,
        //   clientCount: 0
        // }
        this.modeOptions = []
        const { callModelBig, callModelSmall } = res.data
        if (callModelSmall.status !== 1) {
          this.modeOptions.push({ ...callModelSmall, name: '虚拟号直拨线路' })
        }
        if (callModelBig.status !== 1) {
          this.modeOptions.push({ ...callModelBig, name: '真实号回拨线路' })
        }
        // 默认选择虚拟号直拨线路
        const model = this.modeOptions.find(item => item.clientCount)
        if (model) {
          this.clickAdd()
          this.ruleForm.callModel = model.callModel
          this.ruleForm.supplierCode = model.supplierCode
        } else {
          this.$message.warning('坐席数量不足')
        }
      })
    },
    clickAdd () {
      this.dialogVisible = true
      this.dialogTitle = '新增座席'
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.ruleForm = {
        cnoNo: '',
        name: '',
        bindStatus: '',
        // areaCode: '',
        clidNumber_more: [], // 轮选多选
        clidNumber11: [], // 智能外显的多选
        clidNumber_single: [], // 固定单选
        defaultClidNumber11: [], // 智能外显
        clidType: 0, // 默认外显号码规则
        clidRule: 1, // 轮选规则
        rollTimes: 1, // 轮选次
        callModel: '', // 线路类型
        supplierCode: ''
      }
      this.cnoNoAdd = ''
      // 选择号码
      this.getAearNumberList()
    },
    clickSubmit: debounce(function () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.dialogTitle === '分配') {
            manualBindCallCenterUserClient({
              cnoId: this.ruleForm.id,
              bindUserId: this.ruleForm.bindUserId,
              userName: this.ruleForm.userName,
              supplierCode: this.ruleForm.supplierCode
            }).then(res => {
              if (res.code === '0') {
                this.$message.success('分配成功')
                this.dialogVisible = false
                this.getCurrentAccountClients()
              } else {
                this.$message.warning(res.msg)
              }
            })
          } else if (this.dialogTitle === '新增座席') {
            if (this.ruleForm.clidType === 0) {
              this.ruleForm.clidNumbers = [this.ruleForm.clidNumber_single[1]] // 固定单选
              this.ruleForm.defaultClidNumbers = []
            } else if (this.ruleForm.clidType === 1) {
              var arrMore = this.ruleForm.clidNumber_more.map(item => item[1]) // 动态多选
              this.ruleForm.clidNumbers = [...new Set(arrMore)]
            } else {
              var arr = this.ruleForm.clidNumber11.map(item => item[1]) // 智能多选
              this.ruleForm.clidNumbers = [...new Set(arr)]
            }
            if (this.ruleForm.defaultClidNumber11 && this.ruleForm.clidType === 2) {
              var arr2 = this.ruleForm.clidNumber11.map(item => item[1]) // 智能缺省
              this.ruleForm.defaultClidNumbers = [...new Set(arr2)]
            }
            if (this.ruleForm.clidRule == 1) { // 添加保存为随机时，清空轮选次
              this.ruleForm.rollTimes = 1
            }
            const model = this.modeOptions.find(item => item.callModel === this.ruleForm.callModel)
            this.ruleForm.supplierCode = model ? model.supplierCode : ''
            createClient(this.ruleForm).then(res => {
              this.$message.success('新增座席成功')
              this.dialogVisible = false
              this.getCurrentAccountClients()
            })
          } else {
            if (this.ruleForm.clidType == 0) {
              this.ruleForm.clidNumbers = [this.ruleForm.clidNumber_single[1]] // 固定单选
            } else if (this.ruleForm.clidType == 1) {
              var selectNumber_active = [] // 动态多选
              this.ruleForm.clidNumber_more.forEach((item) => { selectNumber_active.push(item[1]) })
              this.ruleForm.clidNumbers = selectNumber_active
              if (this.ruleForm.clidRule == 1) { // 编辑保存为随机时，清空轮选次
                this.ruleForm.rollTimes = 1
              }
            } else {
              var selectNumber = [] // 选择号码
              var selectSmartNumber = [] // 选择智能号码
              this.ruleForm.clidNumber11.forEach((item) => { selectNumber.push(item[1]) })
              if (this.ruleForm.defaultClidNumber11) {
                this.ruleForm.defaultClidNumber11.forEach((item) => { selectSmartNumber.push(item[1]) })
              }
              this.ruleForm.clidNumbers = selectNumber
              this.ruleForm.defaultClidNumbers = selectSmartNumber
            }
            editCurrentAccountClient(this.ruleForm).then(res => {
              this.$message.success('编辑座席成功')
              this.dialogVisible = false
              this.getCurrentAccountClients()
            })
          }
        } else {
          return false
        }
      })
    }, 400),
    queryScrmUsers () {
      this.getDepartUserStructure()
      queryScrmUsers({}).then(res => {
        this.structureList = res.data
      })
    },
    getCurrentAccountClients () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cnoName: this.cnoName,
        cnoNo: this.cnoNo,
        bindStatus: this.bindStatus,
        userIds: this.userIds
      }
      getCurrentAccountClients(data).then(res => {
        this.tableData = this.Global.transformEmptyObject(res.data.list)
        // this.numberLength = this.tableData[0].clidNumber.split(',')[0].length
        this.total = Number(res.data.total)
        this.loading = false
        this.getClientCount()
      }).catch(_ => { this.loading = false })
    },
    // 分页的
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.getCurrentAccountClients()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.getCurrentAccountClients()
    }
  },
  beforeDestroy () {
    // this.$bus.$off('refresh')
  }

}
</script>

<style lang="scss" scoped>
/deep/ .position-error .el-form-item__error {
  top: 56px;
}
.el-cascader {
  height: 32px !important;
  /deep/ .el-input__inner {
    height: 32px !important;
  }
  /deep/.el-cascader__tags .el-tag {
    max-width: 45% !important;
  }
  /deep/ .el-cascader__tags .el-tag > span {
    flex: auto;
  }
  /deep/ .el-cascader-node__postfix {
    top: 50%;
    transform: translateY(-50%);
  }
  /deep/ .el-cascader__search-input {
    min-width: 40px !important;
  }
}
/deep/ .el-select__tags .el-tag {
  max-width: 100px !important;
}
/deep/ .el-select .el-select__tags > span {
  display: contents !important;
}
/deep/ .el-select .el-select__tags > span .el-tag__close.el-icon-close {
  right: -1px;
  top: 3px;
}
/deep/ .el-dialog__footer {
  .el-button {
    width: 100px;
    height: 36px;
    line-height: 36px;
    padding: 0;
  }
}
/deep/ .el-dialog__body {
  padding: 31px 60px 13px 30px;
  border-top: 1px #e5e5e5 solid;
  border-bottom: 1px #e5e5e5 solid;
}
.el-card {
  border: 0;
}
/deep/.el-button--small {
  font-size: 14px;
  padding: 8px 15px;
}
.div-table {
  padding: 24px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .el-button--primary {
    // background: #374fb8;
    // border-color: #374fb8;
    padding: 8.5px 28px;
    margin-left: 24px;
    position: relative !important;
    top: -6px !important;
  }
  .p-title {
    .span-text1 {
      color: #25358a;
    }
    .span-text2 {
      color: #333333;
    }
    .span-text3 {
      font-size: 20px;
      color: #25358a;
      font-weight: bold;
    }
    .span-text4 {
      font-size: 20px;
      color: #333333;
      font-weight: bold;
    }
    .el-button {
      position: relative;
      top: -5px;
    }
  }
}
.span-lable {
  display: inline-block;
  text-align: right;
  width: 60px;
  color: #666;
  font-size: 12px;
  margin-right: 8px;
}
.input-width {
  width: 160px;
}
.showNumber-box {
  position: relative;
  padding-bottom: 10px;
  .tipsWaring {
    position: absolute;
    top: 36px;
    left: 4px;
    line-height: 21px;
    font-size: 12px;
    color: #fa6400;
  }
}
.selectNumber-box {
  padding-top: 10px;
  // padding-bottom: 10px;
}
.selectNumber-box1 {
  padding-top: 25px;
}
.selectNumber_box {
  padding-top: 5px;
}
.el-cascader-panel {
  margin-top: 30px;
}
.select-box {
  position: relative;
}
.totalSelect {
  color: #a6a3a4;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  padding-left: 10px;
  width: 105px;
  border-radius: 4px;
  display: block;
  line-height: 32px;
  position: absolute;
  top: 3px;
  left: 343px;
}
.totalSelectNone {
  display: none;
}
.clearAll {
  cursor: pointer;
}
.ruleTimes_ipt /deep/.el-input__inner {
  padding: 0px !important;
  text-align: center;
}
.max-text {
  position: relative;
  top: 4px;
  display: inline-block;
  width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style lang="scss">
.tree-selectNumber-box {
  margin-top: 8px !important;
  border-top: 1px solid transparent;
}
</style>
